import {
  SET_FILTER_LOCATION,
  SET_HAZARD,
  SET_ANALYSISTYPE,
  SET_STARTYEAR,
  SET_ENDYEAR,
  ERROR_SET_FILTER,
  SET_FILTERED_RESULTS,
  SET_RENDERED_RESULTS,
  CLEAR_FILTERS,
  GET_STATES,
  SET_STATES,
  GET_COUNTIES,
  SET_COUNTIES,
  GET_CITIES,
  SET_CITIES,
  SET_STATE_SELECTED,
  SET_COUNTY_SELECTED,
  SET_CITY_SELECTED,
  FILTER_RESULTS,
  SET_FILTER_ECONOMIC_LOSS_MAX,
  SET_FILTER_ECONOMIC_LOSS_MIN,
} from "./types";
import { resetFilteredResults } from "./results";
import axios from "axios";
import { config } from "./helpers";
import { incrementResults } from "../constants";
const api = process.env.REACT_APP_API;

export const filterResults = () => async (dispatch, getState) => {
  // assign results object
  dispatch({
    type: FILTER_RESULTS,
    payload: null,
  });
  try {
    const { results, filters } = getState();
    if (results.all) {
      let _results = [...results.all];

      // filter by hazard
      let filterArray = Object.keys(filters.hazard).filter(
        (key) => filters.hazard[key]
      );
      _results =
        filterArray.length > 0
          ? _results.filter((result) =>
              filterArray.some((item) => result.hazard.includes(item))
            )
          : _results;

      // filter by analysis type
      filterArray = Object.keys(filters.analysisType).filter(
        (key) => filters.analysisType[key]
      );
      _results =
        filterArray.length > 0
          ? _results.filter((result) =>
              filterArray.some((item) => result.analysisType.includes(item))
            )
          : _results;

      // filter by result type
      filterArray = Object.keys(filters.resultType).filter(
        (key) => filters.resultType[key]
      );
      _results =
        filterArray.length > 0
          ? _results.filter((result) =>
              filterArray.some((item) => result.type.includes(item))
            )
          : _results;

      // filter by date
      if (filters.startYear && filters.endYear) {
        _results = _results.filter(
          (result) =>
            result.date >= filters.startYear && result.date <= filters.endYear
        );
      }

      // filter by scale
      if (filters.scale !== "") {
        _results = _results.filter((result) => result.scale === filters.scale);
      }

      // filter by stateSelected
      if (filters.stateSelected.id !== null) {
        _results = _results.filter((result) => result.location !== null && result.location.includes(filters.stateSelected.id));
      }

      // filter by countySelected
      if (filters.countySelected.id !== null) {
        _results = _results.filter((result) => result.location !== null && result.location.includes(filters.countySelected.id));
      }

      // filter by citySelected
      if (filters.citySelected.id !== null) {
        _results = _results.filter((result) => result.location !== null && result.location.includes(filters.citySelected.id));
      }

      // dispatch filtered results and render result cards
      dispatch({
        type: SET_FILTERED_RESULTS,
        payload: _results,
      });
      const renderResults = _results.slice(0, incrementResults);
      dispatch({
        type: SET_RENDERED_RESULTS,
        payload: renderResults,
      });
    }
  } catch (error) {
    console.error({ msg: "unable to filter results", error: error });
  }
};

export const setLocation = (value) => async (dispatch, getState) => {
  try {
    dispatch({
      type: SET_FILTER_LOCATION,
      payload: value,
    });
    dispatch(filterResults());
  } catch (error) {
    const msg = { msg: "Unable to dispatch filter", error: error.message };
    console.error(msg);
    dispatch({
      type: ERROR_SET_FILTER,
      payload: msg,
    });
  }
};

export const setHazard = (value) => async (dispatch, getState) => {
  try {
    dispatch({
      type: SET_HAZARD,
      payload: value,
    });
    dispatch(filterResults());
  } catch (error) {
    const msg = { msg: "Unable to dispatch filter", error: error.message };
    console.error(msg);
    dispatch({
      type: ERROR_SET_FILTER,
      payload: msg,
    });
  }
};

export const setAnalysisType = (value) => async (dispatch, getState) => {
  try {
    dispatch({
      type: SET_ANALYSISTYPE,
      payload: value,
    });
    dispatch(filterResults());
  } catch (error) {
    const msg = { msg: "Unable to dispatch filter", error: error.message };
    console.error(msg);
    dispatch({
      type: ERROR_SET_FILTER,
      payload: msg,
    });
  }
};

export const setStartYear = (value) => async (dispatch, getState) => {
  try {
    dispatch({
      type: SET_STARTYEAR,
      payload: value,
    });
    const { filters } = getState();
    if (
      (filters.startYear && filters.endYear) ||
      (isNaN(filters.startYear) && isNaN(filters.endYear)) ||
      (filters.startYear === null && filters.endYear === null)
    ) {
      dispatch(filterResults());
    }
  } catch (error) {
    const msg = { msg: "Unable to dispatch filter", error: error.message };
    console.error(msg);
    dispatch({
      type: ERROR_SET_FILTER,
      payload: msg,
    });
  }
};

export const setEndYear = (value) => async (dispatch, getState) => {
  try {
    dispatch({
      type: SET_ENDYEAR,
      payload: value,
    });
    const { filters } = getState();
    if (
      (filters.startYear && filters.endYear) ||
      (isNaN(filters.startYear) && isNaN(filters.endYear)) ||
      (filters.startYear === null && filters.endYear === null)
    ) {
      dispatch(filterResults());
    }
  } catch (error) {
    const msg = { msg: "Unable to dispatch filter", error: error.message };
    console.error(msg);
    dispatch({
      type: ERROR_SET_FILTER,
      payload: msg,
    });
  }
};

export const getStates =
  ({ county, city } = {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: GET_STATES,
        payload: null,
      });
      const data = county || city ? { by: {} } : {};
      if (county) {
        data["by"]["county"] = county;
      }
      if (city) {
        data["by"]["city"] = city;
      }
      const res = await axios.post(`${api}locations/states`, data, {
        config,
      });
      dispatch({
        type: SET_STATES,
        payload: res.data,
      });
    } catch (error) {
      const msg = { msg: "Unable to set search text", error: error.message };
      console.error(msg);
      dispatch({
        type: ERROR_SET_FILTER,
        payload: msg,
      });
    }
  };

export const getCounties =
  ({ state, city } = {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: GET_COUNTIES,
        payload: null,
      });
      const data = state || city ? { by: {} } : {};
      if (state) {
        data["by"]["state"] = state;
      }
      if (city) {
        data["by"]["city"] = city;
      }
      const res = await axios.post(`${api}locations/counties`, data, {
        config,
      });
      dispatch({
        type: SET_COUNTIES,
        payload: res.data,
      });
    } catch (error) {
      const msg = { msg: "Unable to set search text", error: error.message };
      console.error(msg);
      dispatch({
        type: ERROR_SET_FILTER,
        payload: msg,
      });
    }
  };

export const getCities =
  ({ state, county } = {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: GET_CITIES,
        payload: null,
      });
      const data = state || county ? { by: {} } : {};
      if (state) {
        data["by"]["state"] = state;
      }
      if (county) {
        data["by"]["county"] = county;
      }
      const res = await axios.post(`${api}locations/cities`, data, { config });
      dispatch({
        type: SET_CITIES,
        payload: res.data,
      });
    } catch (error) {
      const msg = { msg: "Unable to set search text", error: error.message };
      console.error(msg);
      dispatch({
        type: ERROR_SET_FILTER,
        payload: msg,
      });
    }
  };

export const setStates = (locations) => async (dispatch) => {
  try {
    dispatch({
      type: SET_STATES,
      payload: locations,
    });
  } catch (error) {
    const msg = { msg: "Unable to set states", error: error.message };
    console.error(msg);
    dispatch({
      type: ERROR_SET_FILTER,
      payload: msg,
    });
  }
};
export const setCounties = (locations) => async (dispatch) => {
  try {
    dispatch({
      type: SET_COUNTIES,
      payload: locations,
    });
  } catch (error) {
    const msg = { msg: "Unable to set counties", error: error.message };
    console.error(msg);
    dispatch({
      type: ERROR_SET_FILTER,
      payload: msg,
    });
  }
};
export const setCities = (locations) => async (dispatch) => {
  try {
    dispatch({
      type: SET_CITIES,
      payload: locations,
    });
  } catch (error) {
    const msg = { msg: "Unable to set cities", error: error.message };
    console.error(msg);
    dispatch({
      type: ERROR_SET_FILTER,
      payload: msg,
    });
  }
};

export const setStateSelected = (locationSelected) => async (dispatch) => {
  try {
    dispatch({
      type: SET_STATE_SELECTED,
      payload: locationSelected,
    });
    dispatch(filterResults());
  } catch (error) {
    const msg = { msg: "Unable to set stateSelected", error: error.message };
    console.error(msg);
    dispatch({
      type: ERROR_SET_FILTER,
      payload: msg,
    });
  }
};
export const setCountySelected = (locationSelected) => async (dispatch) => {
  try {
    dispatch({
      type: SET_COUNTY_SELECTED,
      payload: locationSelected,
    });
    dispatch(filterResults());
  } catch (error) {
    const msg = { msg: "Unable to set countySelected", error: error.message };
    console.error(msg);
    dispatch({
      type: ERROR_SET_FILTER,
      payload: msg,
    });
  }
};
export const setCitySelected = (locationSelected) => async (dispatch) => {
  try {
    dispatch({
      type: SET_CITY_SELECTED,
      payload: locationSelected,
    });
    dispatch(filterResults());
  } catch (error) {
    const msg = { msg: "Unable to set citySelected", error: error.message };
    console.error(msg);
    dispatch({
      type: ERROR_SET_FILTER,
      payload: msg,
    });
  }
};

export const clearFilters = () => async (dispatch) => {
  try {
    dispatch(resetFilteredResults());
    dispatch({
      type: CLEAR_FILTERS,
      payload: true,
    });
    dispatch(getStates());
    dispatch(getCounties());
    dispatch(getCities());
  } catch (error) {
    const msg = { msg: "Unable to clear filters", error: error.message };
    console.error(msg);
    dispatch({
      type: ERROR_SET_FILTER,
      payload: msg,
    });
  }
};

export const setFilterEconomicLossMin = (value) => async (dispatch) => {
  try {
    dispatch({
      type: SET_FILTER_ECONOMIC_LOSS_MIN,
      payload: value,
    });
  } catch (error) {
    const msg = {
      msg: "Unable to set filter economic loss min",
      error: error.message,
    };
    console.error(msg);
    dispatch({
      type: ERROR_SET_FILTER,
      payload: msg,
    });
  }
};

export const setFilterEconomicLossMax = (value) => async (dispatch) => {
  try {
    dispatch({
      type: SET_FILTER_ECONOMIC_LOSS_MAX,
      payload: value,
    });
  } catch (error) {
    const msg = {
      msg: "Unable to set filter economic loss min",
      error: error.message,
    };
    console.error(msg);
    dispatch({
      type: ERROR_SET_FILTER,
      payload: msg,
    });
  }
};
